import React from "react";
import { Text } from "@dxp-feed/ui/Text";
import Link from "@/components/Link";
import { SiteContainer } from "@/components/Container";

export default function MobileCategory() {
  return (
    <SiteContainer>
      <Text
        as="ul"
        className="m-0 p-0 list-none flex items-center justify-between text-center"
      >
        <Text as="li">
          <Link
            href="/flyer"
            aria-label="View latest Flyers"
            className="popins"
            prefetch={false}
          >
            <Text
              as="span"
              className="icon-flyer text-brandBlack text-[16px]"
            />
            <Text
              as="span"
              className="text-brandSecondary text-[12px] font-bold leading-normal mt-1 mb-0 block"
            >
              Flyers
            </Text>
          </Link>
        </Text>
        <Text as="li">
          <Link
            href="/offers"
            aria-label="Browse current Offers"
            className="popins"
          >
            <Text as="span" className="icon-tag text-brandBlack text-[16px]" />
            <Text
              as="span"
              className="text-brandSecondary text-[12px] font-[700] leading-normal mt-[4px] mb-0 block"
            >
              Offers
            </Text>
          </Link>
        </Text>
        <Text as="li">
          <Link href="/recipes" aria-label="Explore Recipes" className="popins">
            <Text
              as="span"
              className="icon-spoons text-brandBlack text-[16px]"
            />
            <Text
              as="span"
              className="text-brandSecondary text-[12px] font-[700] leading-normal mt-[4px] mb-0 block"
            >
              Recipes
            </Text>
          </Link>
        </Text>
        <Text as="li">
          <Link
            href="/store-locator"
            aria-label="Find a nearby Store"
            className="popins"
          >
            <Text
              as="span"
              className="icon-store text-brandBlack text-[16px]"
            />
            <Text
              as="span"
              className="text-brandSecondary text-[12px] font-[700] leading-normal mt-[4px] mb-0 block"
            >
              Stores
            </Text>
          </Link>
        </Text>
      </Text>
    </SiteContainer>
  );
}
